import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import SettingEdit from '@/views/setting/Edit.vue';

export const settingAddRoute: RouteConfig = {
  path: 'add',
  name: 'settingAdd',
  component: SettingEdit,
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.settings.add'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('setting/group/list', { count: -1 })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.setting.group.listError' }));
  }
};
